/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { InputType } from '../herbal-business-sign-up';
import { RichTextComponent } from '@msdyn365-commerce/core';

export interface IBusinessSignUpFileUploadProps {
    id?: string;
    type: InputType;
    className: string;
    isRequired: boolean;
    fieldReference?: React.RefObject<HTMLInputElement>;
    multiple: boolean;
    helpText?: string;
    onChange?(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
    onBlur?(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
}

export const SignUpFileUpload: React.FC<IBusinessSignUpFileUploadProps> = ({
    id,
    type,
    className,
    isRequired,
    onChange,
    onBlur,
    fieldReference,
    multiple,
    helpText
}) => {
    return (
        <div>
            <input
                id={id}
                type={type}
                className={`${className}-input ${className}-${id}`}
                aria-required={isRequired}
                onChange={onChange}
                // onBlur={onBlur}
                ref={fieldReference}
                multiple={multiple}
            />
            <div className={'msc-help-text'}>
                <RichTextComponent text={helpText} />
            </div>
        </div>
    );
};

export default SignUpFileUpload;
